// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import * as sdk from '@canton-network/dapp-sdk';
import { useMutation } from '@tanstack/react-query';
import hash from 'object-hash';
import { Choice, Party } from '@daml/types';
import { LedgerExerciseArgs } from '../../../utils/LedgerApiClientV2';

export const useDappSdkExercise = <T extends object, C, R, K>(choice: Choice<T, C, R, K>) => {
  return useMutation({
    mutationKey: ['dappSdkExercise'],
    mutationFn: async (args: LedgerExerciseArgs<T, C>) => {
      let actAs: Party[] | undefined;
      let readAs: Party[] | undefined;

      if (args.submitter) {
        actAs = [args.submitter];
      } else {
        actAs = args.actAs;
        readAs = args.readAs;
      }
      const commandId = hash({
        contractId: args.cid,
        templateId: choice.template().templateId,
        choiceName: choice.choiceName,
        argument: args.argument,
        actAs,
        readAs,
      });

      return sdk.prepareExecute({
        commandId,
        disclosedContracts: args.meta?.disclosedContracts,
        commands: [
          {
            ExerciseCommand: {
              templateId: choice.template().templateId,
              contractId: args.cid,
              choice: choice.choiceName,
              choiceArgument: choice.argumentEncode(args.argument),
            },
          },
        ],
      });
    },
  });
};
